let sources;
let sprites;
let fonts;
if (process.env.NODE_ENV === 'production') {
    let URL = 'https://tiles.nexview.io';
    fonts = `${URL}/fonts/{fontstack}/{range}.pbf`;
    sprites = `${URL}/sprites/sprites`;
    sources = {
        states: {
            url: `${URL}/states/tile.json`,
            type: 'vector'
        },
        land: {
            url: `${URL}/land/tile.json`,
            type: 'vector'
        },
        country_borders: {
            url: `${URL}/country_borders/tile.json`,
            type: 'vector'
        },
        state_borders: {
            url: `${URL}/state_borders/tile.json`,
            type: 'vector'
        },
        lakes: {
            url: `${URL}/lakes/tile.json`,
            type: 'vector'
        },
        roads: {
            url: `${URL}/roads/tile.json`,
            type: 'vector'
        },
        uscities: {
            url: `${URL}/uscities/tile.json`,
            type: 'vector'
        },
        counties: {
            url: `${URL}/counties/tile.json`,
            type: 'vector'
        }
    };
}
else {
    let URL = 'http://localhost:8000/api/v1';
    fonts = `${URL}/fonts/{fontstack}/{range}.pbf`;
    sprites = `${URL}/sprites/sprites`;
    sources = {
        states: {
            tiles: [`${URL}/states/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        land: {
            tiles: [`${URL}/land/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        country_borders: {
            tiles: [`${URL}/country_borders/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        state_borders: {
            tiles: [`${URL}/state_borders/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        lakes: {
            tiles: [`${URL}/lakes/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        roads: {
            tiles: [`${URL}/roads/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        uscities: {
            tiles: [`${URL}/uscities/{z}/{x}/{y}.pbf`],
            type: 'vector'
        },
        counties: {
            tiles: [`${URL}/counties/{z}/{x}/{y}.pbf`],
            type: 'vector'
        }
    };
};

const styles = {
    version: 8,
    name: 'Nexview',
    metadata: {
        'mapbox:autocomposite': true,
        'mapbox:type': 'template',
        'mapbox:trackposition': false
    },
    center: [
        -96.5634227,
        39.218219
    ],
    zoom: 4.50,
    bearing: 0,
    pitch: 0,
    sources: sources,
    sprite: sprites,
    glyphs: fonts,
    layers: [
        {
            id: 'background',
            type: 'background',
            paint: {
                'background-color': 'rgba(27, 27, 45, 1)'
            }
        },
        {
            id: 'land',
            type: 'fill',
            source: 'land',
            'source-layer': 'land',
            paint: {
                'fill-color': 'rgba(12, 12, 12, 1)'
            }
        },
        {
            id: 'lakes',
            type: 'fill',
            source: 'lakes',
            'source-layer': 'lakes',
            paint: {
                'fill-color': 'rgba(27, 27, 45, 1)'
            }
        },
        {
            id: 'lakes_borders',
            type: 'line',
            source: 'lakes',
            'source-layer': 'lakes',
            paint: {
                'line-color': 'rgba(106, 106, 132, 0.5)'
            }
        },
        {
            id: 'land_borders',
            type: 'line',
            source: 'land',
            'source-layer': 'land',
            paint: {
                'line-color': 'rgba(106, 106, 132, 0.5)'
            }
        },
        {
            id: 'country_borders',
            type: 'line',
            source: 'country_borders',
            'source-layer': 'country_borders',
            filter: [
                'all',
                [
                    'in',
                    'sov_a3_l',
                    'MEX',
                    'USA',
                    'CAN'
                ]
            ],
            paint: {
                'line-color': 'rgba(106, 106, 132, 0.5)'
            }
        },
        {
            id: 'state_borders',
            type: 'line',
            source: 'states',
            'source-layer': 'states',
            paint: {
                'line-color': 'rgba(106, 106, 132, 0.5)'
            }
        },
        {
            id: 'county_borders',
            type: 'line',
            source: 'counties',
            'source-layer': 'counties',
            paint: {
                'line-color': 'rgba(106, 106, 132, 0.35)',
                'line-opacity': {
                    stops: [
                        [
                            6,
                            0
                        ],
                        [
                            6.5,
                            1
                        ]
                    ]
                }
            }
        },
        {
            id: 'interstates',
            type: 'line',
            source: 'roads',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    'in',
                    'class',
                    'Interstate'
                ]
            ],
            paint: {
                'line-color': 'rgba(105, 102, 255, 1)',
                'line-opacity': {
                    stops: [
                        [
                            5,
                            0
                        ],
                        [
                            5.5,
                            0.5
                        ]
                    ]
                }
            }
        },
        {
            id: 'federal_highways',
            type: 'line',
            source: 'roads',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    'in',
                    'class',
                    'Federal'
                ]
            ],
            paint: {
                'line-color': 'rgba(105, 102, 255, 0.75)',
                'line-opacity': {
                    stops: [
                        [
                            7,
                            0
                        ],
                        [
                            7.5,
                            0.5
                        ]
                    ]
                }
            }
        },
        {
            id: 'state_highways',
            type: 'line',
            source: 'roads',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    'in',
                    'class',
                    'State'
                ]
            ],
            paint: {
                'line-color': 'rgba(105, 102, 255, 0.5)',
                'line-opacity': {
                    stops: [
                        [
                            7,
                            0
                        ],
                        [
                            7.5,
                            0.5
                        ]
                    ]
                }
            }
        },
        {
            id: 'uscities_micro',
            type: 'symbol',
            source: 'uscities',
            'source-layer': 'uscities',
            filter: [
                'all',
                [
                    'in',
                    'FEATURE',
                    'Populated Place'
                ]
            ],
            layout: {
                'icon-image': 'circle-11',
                'text-size': 10,
                'text-offset': [
                    0,
                    -0.2
                ],
                'icon-size': 0.4,
                'text-font': [
                    'OpenSansRegular'
                ],
                'text-anchor': 'bottom',
                'text-field': '{NAME}'
            },
            paint: {
                'text-color': 'rgba(255, 255, 255, 1)',
                'text-halo-color': 'rgba(0, 0, 0, 0.7)',
                'text-halo-blur': 1,
                'text-halo-width': 1,
                'text-opacity': {
                    stops: [
                        [
                            9,
                            0
                        ],
                        [
                            10.5,
                            1
                        ]
                    ]
                },
                'icon-opacity': {
                    stops: [
                        [
                            9,
                            0
                        ],
                        [
                            10.5,
                            1
                        ]
                    ]
                }
            }
        },
        {
            id: 'uscities_tiny',
            type: 'symbol',
            source: 'uscities',
            'source-layer': 'uscities',
            filter: [
                'all',
                [
                    '<',
                    'POP_2010',
                    1000
                ],
                [
                    'in',
                    'FEATURE',
                    'Civil'
                ]
            ],
            layout: {
                'icon-image': 'circle-11',
                'text-size': 13,
                'text-offset': [
                    0,
                    -0.2
                ],
                'icon-size': 0.7,
                'text-font': [
                    'OpenSansRegular'
                ],
                'text-anchor': 'bottom',
                'text-field': '{NAME}'
            },
            paint: {
                'text-color': 'rgba(255, 255, 255, 1)',
                'text-halo-color': 'rgba(0, 0, 0, 0.7)',
                'text-halo-blur': 1,
                'text-halo-width': 1,
                'text-opacity': {
                    stops: [
                        [
                            9,
                            0
                        ],
                        [
                            9.5,
                            1
                        ]
                    ]
                },
                'icon-opacity': {
                    stops: [
                        [
                            9,
                            0
                        ],
                        [
                            9.5,
                            1
                        ]
                    ]
                }
            }
        },
        {
            id: 'uscities_small',
            type: 'symbol',
            source: 'uscities',
            'source-layer': 'uscities',
            filter: [
                'all',
                [
                    '>=',
                    'POP_2010',
                    1000
                ],
                [
                    '<',
                    'POP_2010',
                    10000
                ],
                [
                    'in',
                    'FEATURE',
                    'Civil'
                ]
            ],
            layout: {
                'icon-image': 'circle-11',
                'text-size': 14,
                'text-offset': [
                    0,
                    -0.2
                ],
                'icon-size': 0.7,
                'text-font': [
                    'OpenSansRegular'
                ],
                'text-anchor': 'bottom',
                'text-field': '{NAME}'
            },
            paint: {
                'text-color': 'rgba(255, 255, 255, 1)',
                'text-halo-color': 'rgba(0, 0, 0, 0.7)',
                'text-halo-blur': 1,
                'text-halo-width': 1,
                'text-opacity': {
                    stops: [
                        [
                            8,
                            0
                        ],
                        [
                            8.5,
                            1
                        ]
                    ]
                },
                'icon-opacity': {
                    stops: [
                        [
                            8,
                            0
                        ],
                        [
                            8.5,
                            1
                        ]
                    ]
                }
            }
        },
        {
            id: 'uscities_medium',
            type: 'symbol',
            source: 'uscities',
            'source-layer': 'uscities',
            filter: [
                'all',
                [
                    '>=',
                    'POP_2010',
                    10000
                ],
                [
                    '<',
                    'POP_2010',
                    100000
                ],
                [
                    'in',
                    'FEATURE',
                    'Civil'
                ]
            ],
            layout: {
                'icon-image': 'circle-11',
                'text-size': 15,
                'text-offset': [
                    0,
                    -0.2
                ],
                'icon-size': 0.7,
                'text-font': [
                    'OpenSansRegular'
                ],
                'text-anchor': 'bottom',
                'text-field': '{NAME}'
            },
            paint: {
                'text-color': 'rgba(255, 255, 255, 1.0)',
                'text-halo-color': 'rgba(0, 0, 0, 0.7)',
                'text-halo-blur': 1,
                'text-halo-width': 1,
                'text-opacity': {
                    stops: [
                        [
                            6,
                            0
                        ],
                        [
                            6.5,
                            1
                        ]
                    ]
                },
                'icon-opacity': {
                    stops: [
                        [
                            6,
                            0
                        ],
                        [
                            6.5,
                            1
                        ]
                    ]
                }
            }
        },
        {
            id: 'uscities_large',
            type: 'symbol',
            source: 'uscities',
            'source-layer': 'uscities',
            filter: [
                'all',
                [
                    '>=',
                    'POP_2010',
                    100000
                ],
                [
                    'in',
                    'FEATURE',
                    'Civil'
                ]
            ],
            layout: {
                'icon-image': 'circle-11',
                'text-size': 16,
                'text-offset': [
                    0,
                    -0.2
                ],
                'icon-size': 0.7,
                'text-font': [
                    'OpenSansRegular'
                ],
                'text-anchor': 'bottom',
                'text-field': '{NAME}'
            },
            paint: {
                'text-color': 'rgba(255, 255, 255, 1)',
                'text-halo-color': 'rgba(0, 0, 0, 0.7)',
                'text-halo-blur': 1,
                'text-halo-width': 1,
                'text-opacity': 1,
                'icon-opacity': 1
            }
        }

    ]
};

export default styles;